import { BaseModal, ModalResultType } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";

export default class ConfirmModal extends BaseModal
{
    public template = Template.lazy('/core/modals/confirm/index.html');

    constructor(message = '', title = 'Confirmation')
    {
        super(title, message);
    }

    public beforeRender(): PromiseLike<void>
    {
        this.data.title = this.pgettext('Title', 'Confirmation');
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        this.element.querySelector('button.yes').addEventListener('click', e =>
        {
            this.close(ModalResultType.YES);
        });
        this.element.querySelector('button.no').addEventListener('click', e =>
        {
            this.close(ModalResultType.NO);
        });
        return super.afterRender();
    }
}